// JsFromRoutes CacheKey dff37e0d44c37b84488723a5901a9c06
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  create: definePathHelper('post', '(/:admin)/custom_operations'),
}
